import React, { Fragment, useState } from 'react';
import useFetchData from '../../../helpers/useFetch';
import AppURL from '../../../constants/AppURL';
import { Grid } from '@mui/material';
import ItemSuppilerCreateView from '../../../components/inventory/setup/item_suppiler/ItemSuppilerCreateView';
import ItemSuppilerListView from '../../../components/inventory/setup/item_suppiler/ItemSuppilerListView';

const ItemSuppilerCreateListView = () => {
    const [onURL, setOnURL] = useState(AppURL.InventoryURL + 'inventory/product/item/suppiler/create/list/view/');
    const { data, loading, error, refetch } = useFetchData(onURL);
    const handleFormSuccess = (): void => {
        refetch();
    };
    return (
        <Fragment>
            <Grid container spacing={3}>
                <Grid item xl={6} md={6} sm={12} xs={12} lg={6}>
                    <ItemSuppilerCreateView handleFormSuccess={handleFormSuccess} />
                </Grid>
                <Grid item xl={6} md={6} sm={12} xs={12} lg={6}>
                    <ItemSuppilerListView handleFormSuccess={handleFormSuccess} setOnURL={setOnURL} results={data} error={error} loading={loading} />
                </Grid>
            </Grid>

        </Fragment>
    )
}

export default ItemSuppilerCreateListView